import { MessageId as MessageIdSchema } from "@redotech/effect-api-shared/ids/definitions";
import { isEmailChannel } from "@redotech/effect-api-shared/models/shopper-ai/conversation/channel-utils";
import type { SaveDraftInput } from "@redotech/effect-api-shared/models/shopper-ai/conversation/draft";
import type { DraftSendStage } from "@redotech/effect-api-shared/models/support-ticket/support-ticket-notification";
import type { SupportTicketDraftResponse } from "@redotech/effect-api-shared/rpc/support-ticket";

export type DraftCollectionItem = Omit<
  SupportTicketDraftResponse,
  "inReplyToMessageId"
> & {
  inReplyToMessageId: string | undefined;
  sendStage?: DraftSendStage;
  sendAt?: string;
};

export function buildSaveDraftPayload(
  item: DraftCollectionItem,
): SaveDraftInput {
  const inReplyToMessageId = item.inReplyToMessageId
    ? MessageIdSchema.make(item.inReplyToMessageId)
    : undefined;
  const plainContent = item.plainContent ?? undefined;
  const mentionedMongoUserIds =
    item.mentionedMongoUserIds && item.mentionedMongoUserIds.length > 0
      ? [...item.mentionedMongoUserIds]
      : undefined;

  // Best-effort hint so the server can skip thread→origin-topic resolution when
  // this save updates an already-persisted draft (see SaveDraftInput.
  // existingDraftId). On the first save the id is an optimistic temp id the
  // server won't find, so it harmlessly falls through to full resolution.
  const existingDraftId = item.id;

  if (isEmailChannel(item.channel)) {
    return {
      threadId: item.threadId,
      inReplyToMessageId,
      content: item.content,
      plainContent,
      attachments: item.attachments,
      mentionedMongoUserIds,
      existingDraftId,
      channel: item.channel,
      channelData: item.channelData ?? {},
    };
  }
  return {
    threadId: item.threadId,
    inReplyToMessageId,
    content: item.content,
    plainContent,
    attachments: item.attachments,
    mentionedMongoUserIds,
    existingDraftId,
    channel: item.channel,
    channelData: null,
  };
}
